// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"ConfirmModal_confirmModal__11S5l","actionButtons":"ConfirmModal_actionButtons__3qdPz","cancelButton":"ConfirmModal_cancelButton__3DsG7"};